import type { MfaAppConfig } from "@dwelldrop/shared";
import { auditActionSource } from "../utils/auditActionSource";

export const VENUE_TOKEN_KEY = "venuehub_venue_token" as const;

export const VENUE_MFA_CONFIG: MfaAppConfig = {
  app: "venue",
  issuer: "DwellDrop Venue",
  tokenStorageKey: VENUE_TOKEN_KEY,
  loginRateKey: (email) => `login:venue:${email}`,
  auditActionSource,
};
